import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { videos } from '@/mocks/videoData';
import VideoCard from '@/components/feature/VideoCard';

export default function FeaturedVideos() {
  const { t } = useTranslation();
  const featured = videos.slice(0, 8);

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            {t('featured_videos')}
          </h2>
          <Link to="/category/dianying" className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap">
            {t('view_all')} <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {featured.map((video) => (
            <VideoCard key={video.id} {...video} />
          ))}
        </div>
      </div>
    </section>
  );
}